<app-purchased-site *ngIf="!purchasedSite()" (site)="purchasedSite.set($event)"></app-purchased-site>

@if (purchasedSite() === 'Other') {
  @if (editable) {
    <form class="form" [formGroup]="warrantyForm" (ngSubmit)="onSubmit()">
      <mat-card-content>
        @if (currentPage() === 'personal') {
          <div class="form-grid name-grid">
            <mat-form-field class="name">
              <mat-label>First Name</mat-label>
              <input matInput [formControl]="warrantyForm.controls.firstname" />
              <mat-error *ngIf="warrantyForm.controls.firstname.invalid">
                {{getErrors(warrantyForm.controls.firstname)}}
              </mat-error>
            </mat-form-field>

            <mat-form-field class="name">
              <mat-label>Last Name</mat-label>
              <input matInput [formControl]="warrantyForm.controls.lastname" />
              <mat-error *ngIf="warrantyForm.controls.lastname.invalid">
                {{getErrors(warrantyForm.controls.lastname)}}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="form-grid full-row">
            <mat-form-field>
              <mat-label>Phone</mat-label>
              <input matInput type="tel" autocomplete="tel-national" id="phone" name="phone" [formControl]="warrantyForm.controls.phone" />
              <mat-error *ngIf="warrantyForm.controls.phone.invalid">
                @if (warrantyForm.controls.phone.hasError('required')) {
                  Phone number is <strong>required</strong>
                } @else {
                  {{getErrors(warrantyForm.controls.phone)}}
                }
              </mat-error>
            </mat-form-field>
          </div>

          <div class="form-grid full-row">
            <mat-form-field>
              <mat-label>Email</mat-label>
              <input matInput type="email" autocomplete="email" name="email" [formControl]="warrantyForm.controls.email" />
              <mat-error *ngIf="warrantyForm.controls.email.invalid">
                {{getErrors(warrantyForm.controls.email)}}
              </mat-error>
            </mat-form-field>
          </div>

          @if (mode === IMode.Claim) {
            <div class="section-title">Shipping Address*</div>
            <div class="form-grid full-row">
              <mat-form-field>
                <mat-label>Address Line 1</mat-label>
                <input matInput autocomplete="address-line1" id="line1" name="line1" [formControl]="warrantyForm.controls.line1" />
                <mat-error *ngIf="warrantyForm.controls.line1.invalid">
                  {{getErrors(warrantyForm.controls.line1)}}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="form-grid full-row">
              <mat-form-field>
                <mat-label>Address Line 2</mat-label>
                <input matInput autocomplete="address-line2" id="line2" name="line2" [formControl]="warrantyForm.controls.line2" />
                <mat-error *ngIf="warrantyForm.controls.line2.invalid">
                  {{getErrors(warrantyForm.controls.line2)}}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="form-grid city-state-grid">
              <mat-form-field class="city">
                <mat-label>City</mat-label>
                <input matInput autocomplete="address-level2" id="city" name="city" [formControl]="warrantyForm.controls.city" />
                <mat-error *ngIf="warrantyForm.controls.city.invalid">
                  {{getErrors(warrantyForm.controls.city)}}
                </mat-error>
              </mat-form-field>

              <mat-form-field class="state">
                <mat-label>State/Province</mat-label>
                <select matNativeControl autocomplete="address-level1" name="state" [formControl]="warrantyForm.controls.state">
                  <option value=""></option>
                  @for (state of getStates(); track state) {
                    <option [value]="state">{{state}}</option>
                  }
                </select>
                <mat-error *ngIf="warrantyForm.controls.state.hasError('required')">
                  State / Province is <strong>required</strong>
                </mat-error>
                <mat-error *ngIf="warrantyForm.controls.state.hasError('invalidStateForCountry')">
                  State / Province is <strong>invalid</strong>
                </mat-error>
              </mat-form-field>
            </div>

            <div class="form-grid zip-country-grid">
              <mat-form-field class="zip">
                <mat-label>Zip / Postal</mat-label>
                <input matInput autocomplete="postal-code" id="zipCode" name="zipCode" [formControl]="warrantyForm.controls.zipCode" />
                <mat-error *ngIf="warrantyForm.controls.zipCode.hasError('required')">
                  <strong>Required</strong>
                </mat-error>
                <mat-error *ngIf="warrantyForm.controls.zipCode.hasError('invalidZipCodeForCountry')">
                  Zip / Postal is <strong>invalid</strong>
                </mat-error>
              </mat-form-field>

              <mat-form-field class="country">
                <mat-label>Country</mat-label>
                <select matNativeControl autocomplete="country-name" name="country" [formControl]="warrantyForm.controls.country" (change)="countryChanged.emit($any({ value: warrantyForm.controls.country.value }))">
                  @for (country of countries; track country) {
                    <option [value]="country">{{country}}</option>
                  }
                </select>
              </mat-form-field>
            </div>

            @if (isAddressValidationPending()) {
              <mat-progress-bar mode="indeterminate" class="address-validation-progress-bar"></mat-progress-bar>
            }

            @if (addressValidationError()) {
              <div class="address-validation-result address-validation-fix">
                <div class="address-validation-title">{{addressValidationError()}}</div>
              </div>
            }

            @if (addressValidationResponse()?.data; as validationData) {
              <div class="address-validation-result" [ngClass]="addressValidationCardClass(validationData.status)">
                <div class="address-validation-title">{{addressValidationTitle(validationData.status)}}</div>

                @if (validationData.errors?.length) {
                  <ul>
                    @for (error of validationData.errors; track error) {
                      <li>{{error}}</li>
                    }
                  </ul>
                }

                @if (applicationService.isAdmin()) {
                  @if (validationData.missingComponents?.length) {
                    <div>Missing: {{validationData.missingComponents?.join(', ')}}</div>
                  }

                  @if (validationData.unconfirmedComponents?.length) {
                    <div>Unconfirmed: {{validationData.unconfirmedComponents?.join(', ')}}</div>
                  }
                }

                @if (validationData.candidates.length) {
                  <div class="address-candidate-list">
                    @for (candidate of validationData.candidates; track $index) {
                      <button mat-stroked-button type="button" class="address-candidate-card" (click)="applyAddressCandidate(candidate, validationData.status)">
                        {{formatAddressCandidate(candidate)}}
                      </button>
                    }
                  </div>
                }
              </div>
            }
          }
        }

        @if (currentPage() === 'warranty') {
          <div class="row">
            <div class="col">
              <mat-form-field>
                <mat-label>Bat Model</mat-label>
                <input type="text" placeholder="Pick one" aria-label="Bat Model" matInput
                  [formControl]="warrantyForm.controls.batModel" [matAutocomplete]="autoBatModel"
                  (input)="modelChanged.emit($event)" />

                <mat-autocomplete #autoBatModel="matAutocomplete" autoActiveFirstOption requireSelection
                  (optionSelected)="modelSelected.emit($event)">
                  @for (row of filteredModels(); track row.model) {
                    <mat-option [value]="row.model">
                      {{row.model}} - {{row.description}}
                    </mat-option>
                  }
                </mat-autocomplete>
                <mat-hint>
                  {{selectedSku()?.sku }}
                </mat-hint>
                <mat-error *ngIf="warrantyForm.controls.batModel.invalid">
                  {{getErrors(warrantyForm.controls.batModel)}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="form-grid full-row">
            <mat-form-field class="full-width" [ngClass]="{ 'waiting': sizes() === undefined }">
              <mat-label>Bat Length </mat-label>
              <mat-select [formControl]="warrantyForm.controls.batLength" (selectionChange)="batLengthChanged.emit($event)">
                @for (size of sizes(); track size) {
                  <mat-option [value]="size">{{size || '*'}}</mat-option>
                }
              </mat-select>
              <mat-error *ngIf="warrantyForm.controls.batLength.hasError('required')">
                Bat Length is <strong>required</strong>
              </mat-error>
            </mat-form-field>
          </div>

          <div class="form-grid full-row">
            <mat-form-field class="full-width" [ngClass]="{ 'waiting': colors() === undefined }">
              <mat-label>Bat Color </mat-label>
              <mat-select [formControl]="warrantyForm.controls.barrelColor" (selectionChange)="batColorChanged.emit($event)">
                @for (color of colors(); track color) {
                  <mat-option [value]="color">{{color || '*'}}</mat-option>
                }
              </mat-select>
              <mat-error *ngIf="warrantyForm.controls.barrelColor.hasError('required')">
                Color is <strong>required</strong>
              </mat-error>
            </mat-form-field>
          </div>

          @if (mode === IMode.Claim) {
            @if (constructionType() !== Construction.WOOD) {
              <div class="form-grid full-row">
                <mat-form-field class="full-width">
                  <mat-label>Player Age</mat-label>
                  <input matInput inputmode="numeric" [formControl]="warrantyForm.controls.playerAge" />
                  <mat-error *ngIf="warrantyForm.controls.playerAge.hasError('required')">
                    Player Age is <strong>required</strong>
                  </mat-error>
                  <mat-error *ngIf="warrantyForm.controls.playerAge.hasError('pattern')">
                    {{getErrors(warrantyForm.controls.playerAge)}}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="form-grid full-row">
                <mat-form-field class="full-width">
                  <mat-label>Level Of Play</mat-label>
                  <mat-select [formControl]="warrantyForm.controls.levelOfPlay">
                    <mat-option value=""></mat-option>
                    @for(record of levelsOfPlay(); track record){
                      <mat-option [value]="record.name">{{record.name}}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            }

            <div class="form-grid full-row">
              <mat-form-field class="full-width">
                <mat-label>Warranty Claim Reason</mat-label>
                <mat-select [formControl]="warrantyForm.controls.reason">
                  <mat-option value=""></mat-option>
                  @for(reason of claimReasons(); track reason) {
                    <mat-option [value]="reason">{{reason}}</mat-option>
                  }
                </mat-select>
                <mat-error *ngIf="warrantyForm.controls.reason.invalid">
                  {{getErrors(warrantyForm.controls.reason)}}
                </mat-error>
              </mat-form-field>
            </div>
          }

          <div class="form-grid full-row">
            <mat-form-field>
              <mat-label>Date of Purchase</mat-label>
              <input matInput [formControl]="warrantyForm.controls.dateOfPurchase"
                [matDatepicker]="picker" [min]="minPurchaseDate" [max]="todaysDate" [maxLength]="10"
              />
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              <mat-error *ngIf="warrantyForm.controls.dateOfPurchase.invalid">
                {{getErrors(warrantyForm.controls.dateOfPurchase)}}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="form-grid full-row">
            <mat-form-field class="full-width">
              <mat-label>Place of Purchase</mat-label>
              <mat-select type="select" label="Place of Purchase" [formControl]="warrantyForm.controls.placeOfPurchase">
                <mat-option value=""></mat-option>
                @for(record of places(); track record){
                  <mat-option [value]="record.name">{{record.name}}</mat-option>
                }
              </mat-select>
              <mat-error *ngIf="warrantyForm.controls.placeOfPurchase.invalid">
                {{getErrors(warrantyForm.controls.placeOfPurchase)}}
              </mat-error>
            </mat-form-field>
          </div>

          @if (warrantyForm.controls.placeOfPurchase.value === OTHER_PLACE_OF_PURCHASE) {
            <div class="form-grid full-row">
              <mat-form-field class="full-width">
                <mat-label>Other Place of Purchase<span aria-hidden="true" class="mat-mdc-form-field-required-marker mdc-floating-label--required"></span></mat-label>
                <input matInput [formControl]="warrantyForm.controls.otherPlace" />
                <mat-error *ngIf="warrantyForm.controls.otherPlace.invalid">
                  {{getErrors(warrantyForm.controls.otherPlace)}}
                </mat-error>
              </mat-form-field>
            </div>
          }

          <div class="label col center" style="font-size: large; padding-bottom: .5em;">
            {{imageMessage()}}
            @if (mode === IMode.Claim) {
              <div style="margin-top: .5em;">Please include one photo showing the area of concern and one photo showing the size of your current bat.</div>
            }
          </div>
          <div class="row gap2em wrap justify-center">
            @for (imageType of getImageTypes(); track imageType) {
              <div class="col box center" style="margin:0;height: fit-content; max-width: 10em;"
                (dragover)="$event.preventDefault()" (dragend)="$event.preventDefault()" (drop)="onDrop($event, imageType)">
                <div class="col full-width">
                  <h4>{{imageType | titlecase}}<span *ngIf="isImageRequired(imageType)" aria-hidden="true" class="mat-mdc-form-field-required-marker mdc-floating-label--required"></span></h4>
                  @if (warrantyForm.get(imageType)?.value) {
                    <img [src]="warrantyForm.get(imageType)?.value" alt="Your file" class="image" />
                  }
                  @else {
                    <div>
                      <mat-icon>cloud_upload</mat-icon>
                      <div>Drag and drop here
                        or&nbsp;
                        <label for="proof_{{imageType}}" class="anchor">
                          Browse files
                        </label>
                      </div>
                    </div>
                  }
                </div>
                <div class="row display-none">
                  <input type="file" accept="image/jpeg,image/png" (change)="onFileSelected($event, imageType)" id="proof_{{imageType}}" />
                </div>
              </div>
            }
          </div>
          <div class="error center" role="alert" *ngIf="imageValidationError()">
            {{imageValidationError()}}
          </div>
          <div class="center" style="padding-top: .5em;">Supported image types: JPG/JPEG and PNG.</div>
          <br />

          <div class="form-grid full-row serial-field" *ngIf="shouldShowSerialFields()">
            <mat-form-field class="full-width">
              <mat-label>Unique Identification Code (Serial Number)</mat-label>
              <input matInput [formControl]="warrantyForm.controls.batIdentificationCode" />
              <mat-error *ngIf="warrantyForm.controls.batIdentificationCode.invalid">
                {{getErrors(warrantyForm.controls.batIdentificationCode)}}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col full-width">
            <div>
              Subscribe to the {{company() | titlecase}} email newsletter?
            </div>
            <div class="box full-width">
              <mat-radio-group aria-label="Select an option" [formControl]="warrantyForm.controls.newsLetter">
                <mat-radio-button [value]="true">Yes,
                  subscribe me to the {{company() | titlecase}} email newsletter.</mat-radio-button>
                <mat-radio-button [value]="false">No, do not subscribe me to the
                  {{company()}} email newsletter.</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
        }
      </mat-card-content>

      <mat-card-actions>
        <div class="row space-around full-width button-container">
          @if (currentPage() === 'warranty') {
            <button mat-raised-button type="button" (click)="backToPersonalInfo()">
              Back
            </button>
          }
          @if (currentPage() === 'personal') {
            <button mat-raised-button type="button" [disabled]="!canContinue()" (click)="onContinue()">
              Continue
            </button>
          } @else {
            <button mat-raised-button type="submit" [disabled]="processing">
              Submit Warranty
              <ng-container *ngIf="mode === IMode.Registration">Registration</ng-container>
              <ng-container *ngIf="mode === IMode.Claim">Claim</ng-container>
            </button>
          }
        </div>
      </mat-card-actions>
    </form>
  } @else {
    <mat-card-content>
      <div class="col gap2em">
        <div class="row gap2em">
          <div>Name</div>
          <div class="field">{{warrantyForm.controls.firstname.value}}
            {{warrantyForm.controls.lastname.value}}</div>
        </div>

        <div class="row gap2em">
          <div>Phone</div>
          <div class="field">{{warrantyForm.controls.phone.value}} </div>
        </div>

        <div class="row gap2em">
          <div>Email</div>
          <div class="field">{{warrantyForm.controls.email.value}}</div>
        </div>

        @if (mode === IMode.Claim) {
          <div>Shipping Address</div>
          <div class="col ">
            <div class="field">{{warrantyForm.controls.line1.value}}</div>
            <div class="field" *ngIf="warrantyForm.controls.line2.value">{{warrantyForm.controls.line2.value}}</div>
            <div class="field">{{warrantyForm.controls.city.value}} &nbsp; &nbsp;
              {{warrantyForm.controls.state.value}}&nbsp; &nbsp;
              {{warrantyForm.controls.zipCode.value}}&nbsp; &nbsp;
              {{warrantyForm.controls.country.value}}</div>
          </div>
        }

        <div class="row gap4em wrap">
          <div class="row gap2em">
            <div>Bat Model</div>
            <div class="field">{{warrantyForm.controls.batModel.value}}</div>
          </div>

          <div class="row gap2em">
            <div>Bat Length </div>
            <div class="field">{{warrantyForm.controls.batLength.value}}</div>
          </div>
        </div>

        <div class="row gap2em">
          <div>Bat Color </div>
          <div class="field">{{warrantyForm.controls.barrelColor.value}}</div>
        </div>

        @if (constructionType() !== Construction.WOOD) {
          <div class="row gap4em wrap">
            <div class="row gap2em">
              <div>Player Age</div>
              <div class="field">{{warrantyForm.controls.playerAge.value}}</div>
            </div>
            <div class="row gap2em">
              <div>Level of Play</div>
              <div class="field"> {{warrantyForm.controls.levelOfPlay.value}}</div>
            </div>
          </div>
        }
        @if (mode === IMode.Claim) {
          <div class="col">
            <div>Warranty Claim Reason</div>
            <div class="grow field">{{warrantyForm.controls.reason.value}}</div>
          </div>
        }

        <div class="row gap2em">
          <div>Date of Purchase</div>
          <div class="field">{{warrantyForm.controls.dateOfPurchase.value | date }} </div>
        </div>
        <div class="row gap2em">
          <div>Place of Purchase</div>
          <div class="field">{{warrantyForm.controls.otherPlace.value ?? warrantyForm.controls.placeOfPurchase.value}}
          </div>
        </div>

        <div class="row gap2em wrap" *ngIf="hasUploadedImages()">
          @for (imageType of getImageTypes(); track imageType) {
            <div class="col" *ngIf="warrantyForm.get(imageType)?.value">
              <div>{{imageType | titlecase}}</div>
              <img [src]="warrantyForm.get(imageType)?.value" alt="Your uploaded file" class="image" />
            </div>
          }
        </div>

        <div class="row gap2em" style="padding-bottom: 2em;" *ngIf="shouldShowSerialFields()">
          <div>Unique Identification Code (Serial Number)</div>
          <div class="field">{{warrantyForm.controls.batIdentificationCode.value}}</div>
        </div>
      </div>
    </mat-card-content>
    <mat-card-actions *ngIf="canCreateClaim">
      <div class="row space-around">
        <button mat-raised-button type="button" (click)="createClaim.emit()">
          Create Claim
        </button>
      </div>
    </mat-card-actions>
  }
}
